/**
 * External Dependencies
 */
import 'jquery'; // jQuery

import AOS from 'aos'; // Animate On Scroll
import SmoothScrollTop from 'smooth-scroll-top'; // Smooth Scroll Top
import SimpleParallax from "simple-parallax-js"; // Simple Parallax

import './components/responsive';

import Swiper from 'swiper/bundle'; // Swiper JS
import 'swiper/css/bundle'; // import Swiper styles

/* import mmenu + menu */
import 'mmenu-js';
import './components/menu';
import simpleParallax from "simple-parallax-js";

$(() => {
  /**
   * WP Evo Theme version
   */
  console.log('- 💎 WP Evo Theme v0.0.1 - Made with 💗 - ©️ S2i Evolution');

  //////////////////////
  // AXEPTIO //
  /////////////////////

  window._axcb = window._axcb || [];
  window._axcb.push(function(sdk){

    console.log('axeptio SDK - loaded');

    $('.axeptio').on('click touch', function(){
      sdk.openCookies();
    });
  });

  ///////// Init AOS  /////////
  AOS.init({
    //disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    //disable: 'mobile',
    once: true,
    animatedClassName: 'aos-animate', // class applied on animation
  });
  console.log('[lib] > Animate On Scroll loaded');

  ///////// Init Smooth Scroll Top  /////////
  const scrollTop = new SmoothScrollTop({
    position: 'right',
    bgColor: '#90CC3A',
  });
  scrollTop.init();
  console.log('[lib] > Smooth Scroll Top loaded');

  check_header();
  $(window).on("scroll", check_header);
  $(window).on("resize", check_header);

  ///////// Init Simple Parallax  /////////
  const simpleParallax = require('simple-parallax-js');

  if($(window).width() > 	320) {

    var image = document.getElementsByClassName('thumbnail');
    new simpleParallax(image, {
      orientation: 'right',
      transition: 'cubic-bezier(0,0,0,1)',
      overflow: true
    });

    var image_left = document.getElementsByClassName('thumbnail-left');
    new simpleParallax(image_left, {
      orientation: 'left',
      delay: .6,
      transition: 'cubic-bezier(0,0,0,1)',
      overflow: true
    });

    var image_scroll = document.getElementsByClassName('thumbnail-scroll');
    new simpleParallax(image_scroll, {
      delay: .6,
      transition: 'cubic-bezier(0,0,0,1)'
    });

    var image_scroll2 = document.getElementsByClassName('thumbnail-img');
    new simpleParallax(image_scroll2, {
      delay: .6,
      transition: 'cubic-bezier(0,0,0,1)',
      overflow: true
    });

  }

  /// SCROLL ///
  // $('a[href^="#"]').not('.menu-trigger').addClass("scroll");

  $('.scroll').on('click touch', function () { // Au clic sur un élément
    scrollTo(this.hash, 750);
  });

  //$(document).on("scroll", onScroll);

  ///// CLIC SUR LES CARDS /////
  $('.card').on('click', function () {
    if( $(this).find('a').attr('target') == '_blank'){
      window.open($(this).find('a').attr('href'), '_blank');
    } else {
      document.location.href = $(this).find('a').attr('href');
    }
  });

///// SWIPE JS /////
  const slider = new Swiper('.mySwiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // Responsive
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    mousewheel: false,
    keyboard: true,
  });

  var swiperlogos = new Swiper(".mySwiperlogos", {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      reverseDirection: false,
      waitForTransition: false,
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-logos-next",
      prevEl: ".swiper-button-logos-prev",
    },
    // Responsive
    breakpoints: {
      768: {
        slidesPerView: 6,
        spaceBetween: 40,
      },
    },
  });

  $('.customSwiper').each( function(i) {

    var el = $(this);
    var parent = el.parent();
    var pagi = $(".swiper-pagination")[i];
    var pagiNext = $(".swiper-button-next")[i];
    var pagiPrev = $(".swiper-button-prev")[i];

    if(el.data('dispo') == 3) {
      var customBreak = {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      };
    }

    if(el.data('dispo') == 6) {
      var customBreak = {
        120: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1536: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
      };
    }

    if(el.data('dispo') == 4) {
      var customBreak = {
        576: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1536: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      };
    }

    var customSlider = new Swiper(el[0], {
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
        reverseDirection: false,
        waitForTransition: false,
      },
      loop: true,
      pagination: {
        el: pagi,
        dynamicBullets: true,
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // Responsive
      breakpoints: customBreak,
      mousewheel: false,
      keyboard: true,
    });
  });



///// CONTENU ACCORDEON COLLASPE /////
  /* Optional Javascript to close the radio button version by clicking it again */
  var myRadios = document.getElementsByName('tabs2');
  var setCheck;
  var x = 0;
  for(x = 0; x < myRadios.length; x++){
    myRadios[x].onclick = function(){
      if(setCheck != this){
        setCheck = this;
      }else{
        this.checked = false;
        setCheck = null;
      }
    };
  }

});

function scrollTo(page, speed) {
  $('html, body').animate({ scrollTop: $(page).offset().top - $('header').height() }, speed); // Go
  return false;
}

///// FIXED HEADER /////
function check_header() {
  if ($(window).scrollTop() < 1 && $(window).width() > 320) {
    $("header").removeClass("second_style");
  }
  if ($(window).scrollTop() >= 1 || $(window).width() < 320) {
    $("header").addClass("second_style");
  }
}


